<template>
  <div>
    <span v-if="notice.pausedCount && notice.pausedCount === notice.residualCount"
      >文件{{ getTaskLabel(taskType) }}已暂停...</span
    >
    <span v-else-if="notice.residualCount">文件{{ getTaskLabel(taskType) }}中...</span>
    <span v-else>{{ getTaskLabel(taskType) }}完成</span>
    <span v-if="notice.residualCount">（剩余 {{ notice.residualCount }} 项 ）</span>
    <span v-else>
      <template v-if="notice.errorCount !== 0">
        <span>（ {{ notice.successCount }} 项成功，</span>
        <span>
          <span :class="notice.errorCount > 0 ? 'error' : ''"> {{ notice.errorCount }} 项失败 </span>
          ）
        </span>
      </template>
    </span>
  </div>
</template>
<script lang="ts" setup>
  import type { PropType } from 'vue'
  import type { TransmissionMessage } from '@/core/Notification/NotificationManager'
  import { TaskType } from '@/core/transmission/TransmissionNoticeManager'

  defineProps({
    notice: {
      type: Object as PropType<TransmissionMessage>,
      default: null,
    },
    taskType: {
      type: Number as PropType<TaskType>,
      default: TaskType.UPLOAD,
    },
  })
  const getTaskLabel = (taskType: TaskType) => (taskType === TaskType.UPLOAD ? '上传' : '下载')
</script>
<style scoped lang="stylus">
  .error
    color #ff4d4f
</style>
